import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LyTheme, shadowBuilder } from 'alyle-ui/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as _chroma from 'chroma-js';
var chroma = _chroma;
var LyShadowService = /** @class */ (function () {
    function LyShadowService(sanitizer, platformId, theme) {
        this.sanitizer = sanitizer;
        this.platformId = platformId;
        this.theme = theme;
        /** Default elevation */
        this.elevation = 1;
    }
    /** demo: setShadow([elevation, color]) */
    /** demo: setShadow([elevation, color]) */
    LyShadowService.prototype.setShadow = /** demo: setShadow([elevation, color]) */
    function (elementRef, renderer, val, _lastClass) {
        var keys;
        var elevation;
        var color = 'colorShadow';
        if (val) {
            keys = val.join();
            elevation = val[0];
            color = val[1] || color;
        }
        else {
            keys = "" + this.elevation;
            elevation = this.elevation;
        }
        var newStyle = this.theme.createStyle("ly-" + keys, this._css.bind(this), elevation, color);
        this.theme.updateClass(elementRef, renderer, newStyle.id, _lastClass);
        return newStyle.id;
    };
    LyShadowService.prototype._css = function (elevation, color) {
        if (color === void 0) { color = ''; }
        return "" + shadowBuilder(elevation, this.theme.colorOf(color));
    };
    LyShadowService.prototype.shadow = function (color, size) {
        if (isPlatformBrowser(this.platformId)) {
            var sizeOrigin = size;
            // const _color = chroma(converterToHex(chroma(color).css('hsl'))).get('rgba');
            // const _color = chroma(color).rgba();
            var opacity = chroma(color).alpha();
            var hex = chroma.mix('#fff', color, opacity).hex();
            var rgb = chroma(hex).rgb();
            var style = getShadow(size, rgb);
            // let style = `
            // rgba(${_color[0]}, ${_color[1]}, ${_color[2]}, ${
            //   ((70 / 100) * Number(size / 2))
            // }) 0px ${
            //   (((3 * size) - 2) / 2) * toPositiveNumber(sizeOrigin, true)
            // }px ${
            //   (3 * size * 2) / 2
            // }px 0px${
            //   ','
            // } rgba(${_color[0]}, ${_color[1]}, ${_color[2]}, ${
            //   ((60 / 100) * Number('0.' + String(size)))
            // }) 0px ${
            //   (((3 * size) - 2) / 3) * toPositiveNumber(sizeOrigin, true)
            // }px ${
            //   (3 * size * 2)
            // }px 0px${
            //   ','
            // } rgba(${_color[0]}, ${_color[1]}, ${_color[2]}, ${
            //   (40 / 100) * Number('0.' + String(size))
            // }) 0px ${
            //   (((3 * size) - 2)) * toPositiveNumber(sizeOrigin, true)
            // }px ${(3 * size * 2) / 1.4}px 0px`;
            // if (size < 2 && size > 0) {
            //   style = style + `, rgba(${_color[0]}, ${_color[1]}, ${_color[2]}, ${
            //     .23
            //   }) 0px ${2 * toPositiveNumber(sizeOrigin, true)}px 6px 0px`;
            // }
            return this.sanitizer.bypassSecurityTrustStyle(style);
        }
        else {
            return '';
        }
    };
    LyShadowService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    LyShadowService.ctorParameters = function () { return [
        { type: DomSanitizer, },
        { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] },] },
        { type: LyTheme, },
    ]; };
    return LyShadowService;
}());
export { LyShadowService };
function getShadow(level, rgb) {
    var v = asfdtyd(1, 19, level), blur = asfdtyd(3, 38, level), opacity = asfdtyd(12, 30, level) / 100, v2 = asfdtyd(1, 15, level), blur2 = asfdtyd(2, 12, level), opacity2 = asfdtyd(24, 22, level) / 100, v3 = asfdtyd(1, 10, level), blur3 = asfdtyd(10, 38, level), size = asfdtyd(0, -7, level), opacity3 = asfdtyd(12, 32, level) / 100;
    return "0 " + v + "px " + blur + "px rgba(" + rgb.join() + "," + opacity + "), 0 " + v2 + "px " + blur2 + "px rgba(" + rgb.join() + "," + opacity2 + "), 0 " + v3 + "px " + blur3 + "px " + size + "px rgba(" + rgb.join() + "," + opacity3 + ")";
}
function asfdtyd(min, max, level) {
    var val = min;
    val += ((max - min) / 9) * (Math.abs(level) - 1);
    val *= Math.sign(level);
    return val;
}
//# sourceMappingURL=shadow.service.js.map